<template>
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-portrait">
    <path d="M12 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H12C13.1 18 14 17.1 14 16V2C14 0.9 13.1 0 12 0ZM12 16H2V2H12V16Z" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: "IconPortrait",
  props: {
    color: {
      type: String,
      default: '#212121'
    }
  }
}
</script>
